/** @module Camunda/ProcessViewHeader */
define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/html",
	"csi/html/Widget",
	"csi/locale",
	"csi/widget/UserCollection",
	"csi/xml",
	"dojo/text!./ViewHeader.html"
], function(declare,_,csi,html,Widget,locale,UserCollection,xml,template) {

	/**
	 * Render number of tasks that match given active state
	 * @param {Node[]} tasks
	 * @param {boolean} bActive
	 * @param {DOMNode} domNode
	 */
	function _renderTaskCount(tasks, bActive, domNode) {
		const matchingTasks = bActive ? _.where(tasks, {ActivityState: "CamundaActivityState:Started"}) : _.filter(tasks, function(task) { return task.ActivityState != "CamundaActivityState:Started"; });
		html.text(domNode, String(matchingTasks.length));
	}

	return declare(Widget, {
		templateString: template,

		/**
		 * @override
		 * Custom processing of view keys
		 */
		_processKey: function(ctx, key, def, domNode) {
			const process = ctx.getNode();
			const tasks = ctx.cache.getNodes(process.Tasks);

			switch(key) {
				case "completed":
					_renderTaskCount(tasks, false, domNode);
					return;

				case "running":
					_renderTaskCount(tasks, true, domNode);
					return;

				case "participants":
					const userUrls = _.without(_.uniq(_.pluck(tasks, "Assignee")), csi.EMPTY_URL);

					if (userUrls.length) {
						new UserCollection({
							cache: ctx.cache,
							userUrls: userUrls
						}).placeAt(domNode);
					}

					return;
			}

			return this.inherited(arguments);
		}
	});
});
